import { PagesPrefixEnum } from '~/enums/PagesPrefixEnum'
import type { LocationQueryRaw, RouteLocationRaw } from 'vue-router'

interface RouteParamsInterface {
  [key: string]: string | null
}

export default (
  routeName: string,
  routeParams: RouteParamsInterface = {},
  query: LocationQueryRaw = {}
): RouteLocationRaw => {
  const route = {
    name: routeName,
    params: routeParams,
    query,
  }

  const locale = useState<string>('locale.setting')
  if (locale.value) {
    route.name = `${PagesPrefixEnum}${routeName}`
    route.params.locale = locale.value
  }

  return route
}
